import { render, staticRenderFns } from "./detailPost.vue?vue&type=template&id=3afc5112&scoped=true&"
import script from "./detailPost.vue?vue&type=script&lang=js&"
export * from "./detailPost.vue?vue&type=script&lang=js&"
import style0 from "./detailPost.vue?vue&type=style&index=0&id=3afc5112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc5112",
  null
  
)

export default component.exports